import React, { useMemo } from "react";
import { Input } from "@/components/ui/input";

/**
 * Thousand-separator (id-ID: dot) money input.
 *
 * Displays "2.000.000" while the admin types, but calls onChange with the
 * raw numeric value (Number or null) so callers can persist a clean integer.
 *
 * Props:
 *  - value: number | string | null  — the raw numeric value from parent state
 *  - onChange: (num: number | null) => void
 *  - placeholder: string (numeric example)
 *  - "data-testid": kebab-case id (required)
 */
export default function MoneyInput({ value, onChange, placeholder, ...rest }) {
  const display = useMemo(() => {
    if (value === null || value === undefined || value === "") return "";
    const n = Number(value);
    if (!Number.isFinite(n)) return "";
    return n.toLocaleString("id-ID");
  }, [value]);

  const handleChange = (e) => {
    // Keep only digits — strip dots/commas/spaces/currency chars.
    const digits = (e.target.value || "").replace(/[^\d]/g, "");
    if (digits === "") {
      onChange(null);
      return;
    }
    onChange(Number(digits));
  };

  return (
    <Input
      inputMode="numeric"
      type="text"
      value={display}
      onChange={handleChange}
      placeholder={placeholder}
      {...rest}
    />
  );
}
